module.exports = __webpack_public_path__ + "img/products-2@2x.b901dab.webp";